export default "__VITE_ASSET__4e5fff21__"